export { default as Navbar } from "./navbar/Navbar";
export { default as Footer } from "./footer/Footer";
// export { default as ViewPageOutlet } from "./viewPageOutlet/ViewPageOutlet";
export { default as PageNotFound } from "./pageNotFound/PageNotFound";

export { default as SideMenuBar } from "./sideMenuBar/SideMenuBar";
